export const copy = <T>(obj: T): T => {
  if (typeof window !== 'undefined' && 'structuredClone' in window) {
    return structuredClone(obj);
  } else {
    return JSON.parse(JSON.stringify(obj));
  }
};
